import { toPattern as r } from "vanilla-masker";

var n = {
  fallback: {
    currency: "BRL"
  },
  "pt-BR": {
    currency: "BRL"
  }
},
    e = {
  currency: function currency(r, e) {
    void 0 === e && (e = {
      language: window.navigator.language
    });

    var t = e.language,
        c = function (r, n) {
      var e = {};

      for (var t in r) {
        Object.prototype.hasOwnProperty.call(r, t) && -1 === n.indexOf(t) && (e[t] = r[t]);
      }

      return e;
    }(e, ["language"]);

    return Number(parseFloat(r.indexOf(".") > -1 ? r : r / 100)).toLocaleString(t, Object.assign({}, {
      style: "currency",
      currency: n[t] ? n[t].currency : n.fallback.currency,
      currencyDisplay: "symbol",
      minimumFractionDigits: 2
    }, c));
  },
  percent: function percent(r) {
    return r && parseFloat(r).toFixed(2).replace(".", ",").replace(/(\d)(?=(\d{3})+,)/g, "$1.") + " %";
  }
},
    t = function t(r, n) {
  return r.replace("currency" === n ? /\D/g : /\W/g, "");
},
    c = function c(n, e, t) {
  return r(n, Object.assign({}, {
    pattern: e
  }, t));
},
    a = function a(r, n, _a) {
  return "string" == typeof n ? e[n] ? e[n](r || "", _a) : c(r, n || "", _a) : function (r, n, e) {
    return c(r, n.reduce(function (n, e) {
      return r.length <= t(n).length ? n : e;
    }, n[0]), e);
  }(r, n, _a);
};

export { t as unMask, a as mask };